
import { FormItemType } from "../../../UI/view/component-map";
import { FormView } from "../../../UI/view/form-view";
import { initView } from "../../../UI/view/view";
import { billingPermissions } from "../billing-datasource";
import { liquidMainDataSource } from "./liquid-billing-datasource";
import { LiquidBillingInvoices } from "./liquid-invoice-list";
import { LiquidBillingAutomaticList } from "./liquid-invoice-list-automatic";
import { LiquidBillingCreditList } from "./liquid-invoice-list-credit";
import { LiquidBillingDeliveryList } from "./liquid-invoice-list-delivery";
import { LiquidBillingErrorList } from "./liquid-invoice-list-errors";
import { LiquidBillingJDEStuckList } from "./liquid-invoice-list-jde-stuck";
import { LiquidBillingManualList } from "./liquid-invoice-list-manual";
import { InvoiceListStats } from "./liquid-invoice-list-stats";
import { UnlinkedCreditInvoices } from "./liquid-invoice-list-unlinked";

export const liquidMain = {
  pageHeader: 'Liquid Billing',
  permissions: billingPermissions,
  breadcrumbs: [
    {
      name: 'Liquid Billing',
      icon: 'currency-dollar',
      to: '/billing/liquidproduct',
    },
  ],
  items: [
    {
      type: FormItemType.tab,
      items: [
        {
          label: 'JDE Issues',
          badgeCounter: (state) => {
            return state.liquidbillingerror?.data?.length;
          },
          unMountOnExit: true,
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingErrorList,
              name: 'liquidBillingErrorList',
            }
          ]
        },
        {
          label: 'Pending Credit',
          mountOnEnter: false,
          badgeCounter: (state) => {
            return state.liquidbillingcredit?.data?.length;
          },
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingCreditList,
              name: 'liquidBillingCreditList',
            }
          ]
        },
        {
          label: 'Pending Delivery',
          mountOnEnter: false,
          badgeCounter: (state) => {
            return state.liquidbillingdelivery?.data?.length;
          },
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingDeliveryList,
              name: 'liquidBillingDeliveryList',
            }
          ]
        },
        {
          label: 'Pending Automatic',
          mountOnEnter: false,
          badgeCounter: (state) => {
            return state.liquidbillingautomatic?.data?.length;
          },
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingAutomaticList,
              name: 'liquidBillingAutomaticList',
            }
          ]
        },
        {
          label: 'Pending Manual',
          mountOnEnter: false,
          badgeCounter: (state) => {
            return state.liquidbillingmanual?.data?.length;
          },
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingManualList,
              name: 'liquidBillingManualList',
            }
          ]
        },
        {
          label: 'Stuck In JDE',
          mountOnEnter: false,
          badgeCounter: (state) => {
            return state.liquidbillingjde?.data?.length;
          },
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingJDEStuckList,
              name: 'jdeStuckList',
            }
          ]
        },
        {
          label: 'All Invoices',
          unMountOnExit: true,
          items: [
            {
              type: FormItemType.customComponent,
              component: LiquidBillingInvoices,
              name: 'liquidBillingList',
            }
          ]
        },
        {
          label: 'Monthly Stats',
          unMountOnExit: true,
          items: [
            {
              type: FormItemType.customComponent,
              component: InvoiceListStats,
              name: 'invoiceListStats',
            }
          ]
        }
      ]
    }
  ]
} as FormView;

export const LiquidBillingMain = initView({ form: liquidMain, dataSource: liquidMainDataSource })